// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { IoCloseSharp } from 'react-icons/io5';
// import { BASE_URL } from '../../constant/api';

// function CartModal({ selectedMProduct, isCmodalOpen, closeCmodal, onCartUpdate }) {
//     const [quantity, setQuantity] = useState(0); // Default quantity
//     const [additionalQuantity, setAdditionalQuantity] = useState(0); // Additional quantity
//     const [loading, setLoading] = useState(false);
//     const [productData, setProductData] = useState({});

//     useEffect(() => {
//         if (selectedMProduct) {
//             setProductData(selectedMProduct.productData || {});
//             setQuantity(selectedMProduct.quantity || 0);
//         }
//     }, [selectedMProduct]);

//     const editToCart = async (product, totalQuantity) => {
//         if (!product || !product.product_id) {
//             console.error('Invalid product or missing product ID:', product);
//             return;
//         }

//         setLoading(true);

//         try {
//             const token = localStorage.getItem('token');
//             const sessionId = localStorage.getItem('sessionid');
//             const headers = token
//                 ? { Authorization: `Token ${token}` }
//                 : { 'Session-Id': sessionId };

//             // API request
//             await axios.post(
//                 `${BASE_URL}/orders/update-cart/`,
//                 { product_id: product.product_id, quantity: totalQuantity },
//                 { headers }
//             );

//             // Notify parent to update cart
//             if (onCartUpdate) {
//                 onCartUpdate({ productId: product.product_id, quantity: totalQuantity });
//             }

//             // Update local state
//             setQuantity(totalQuantity - additionalQuantity);
//             setAdditionalQuantity(0);

//             closeCmodal(); // Close the modal
//         } catch (error) {
//             console.error('Error updating product in cart:', error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const totalQuantity = quantity + additionalQuantity;

//     return (
//         <div>
//             {isCmodalOpen && selectedMProduct && (
//                 <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-20">
//                     <div className="bg-white p-6 rounded-lg max-w-md w-auto md:w-full shadow-lg">
//                         <div className="flex justify-between items-center">
//                             <h2 className="text-xl font-semibold mb-4">
//                                 {productData.name || 'Product Name'}
//                             </h2>
//                             <span
//                                 className="text-2xl cursor-pointer"
//                                 onClick={closeCmodal}
//                             >
//                                 <IoCloseSharp />
//                             </span>
//                         </div>

//                         <p className="line-clamp-2">{productData.description || 'No description available.'}</p>
//                         <p className="text-lg font-bold mt-2">
//                             Price: ${productData.price || '0.00'}
//                         </p>

//                         {/* Minimum Quantity Selection */}
//                         <label className="block my-4">
//                             <span className="text-gray-700">Select Minimum Quantity</span>
//                             <div className="flex flex-row justify-between mt-2">
//                                 {[productData.min_order_quantity, productData.min_order_quantity_two,
//                                     productData.min_order_quantity_three, productData.min_order_quantity_four,
//                                     productData.min_order_quantity_five]
//                                     .filter((qty) => qty)
//                                     .map((qty) => (
//                                         <div
//                                             key={qty}
//                                             onClick={() => setQuantity(qty)}
//                                             className={`cursor-pointer p-4 border rounded-lg hover:border-brand-primary hover:text-brand-primary text-center ${
//                                                 quantity === qty
//                                                     ? 'bg-brand-primary transition ease-in-out hover:text-white duration-500 text-white'
//                                                     : 'bg-white'
//                                             }`}
//                                         >
//                                             {qty}
//                                         </div>
//                                     ))}
//                             </div>
//                         </label>

//                         {/* Additional Quantity Input */}
// <label className="block my-4">
//     <span className="text-gray-700">Add Additional Quantity</span>
//     <input
//         type="number"
//         value={additionalQuantity === 0 ? '' : additionalQuantity}
//         onChange={(e) => {
//             const value = Number(e.target.value);
//             setAdditionalQuantity(isNaN(value) ? 0 : value);
//         }}
//         className="w-full p-2 border rounded mt-2"
//         placeholder="Enter additional quantity"
//         min="0"
//     />
// </label>


//                         <div className="mt-2 text-lg font-semibold">
//                             Total Quantity: {totalQuantity}
//                         </div>
//                         <div className="mt-2 text-lg font-semibold">
//                             Total Price: ${(productData.price * totalQuantity || 0).toFixed(2)}
//                         </div>

//                         {/* Action Button */}
//                         <div className="flex justify-between space-x-4 mt-4">
//                             <button
//                                 onClick={(e) => {
//                                     e.preventDefault();
//                                     editToCart(selectedMProduct, totalQuantity);
//                                 }}
//                                 className="hover:bg-brand-primary text-brand-primary px-4 py-2 rounded w-full border-brand-primary border-solid border-2 hover:text-brand-secondary-gray ease-in duration-200"
//                                 disabled={loading}
//                             >
//                                 {loading ? 'Adding...' : 'Edit to Cart'}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// }

// export default CartModal;
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { IoCloseSharp } from 'react-icons/io5';
import { BASE_URL, USER_URL } from '../../constant/api';

function CartModal({ selectedMProduct, isCmodalOpen, closeCmodal, onCartUpdate }) {
    const [quantity, setQuantity] = useState(0); // Default quantity
    const [enteredQuantity, setEnteredQuantity] = useState(0); // Entered quantity
    const [loading, setLoading] = useState(false);
    const [productData, setProductData] = useState({});

    useEffect(() => {
        if (selectedMProduct) {
            setProductData(selectedMProduct.productData || {});
            setQuantity(selectedMProduct.quantity || 0);
            setEnteredQuantity(0); // Reset entered quantity
        }
    }, [selectedMProduct]);

    const editToCart = async (product, totalQuantity) => {
        if (!product || !product.product_id) {
            console.error('Invalid product or missing product ID:', product);
            return;
        }

        setLoading(true);

        try {
            // const token = localStorage.getItem('token');
            // const sessionId = localStorage.getItem('sessionid');
            // const headers = token
            //     ? { Authorization: `JWT ${token}` }
            //     : { 'Session-Id': sessionId };

            // API request
            await USER_URL.post(
                `/orders/update-cart/`,
                { product_id: product.product_id, quantity: totalQuantity },
                // { headers }
            );

            // Notify parent to update cart
            if (onCartUpdate) {
                onCartUpdate({ productId: product.product_id, quantity: totalQuantity });
            }

            // Update local state
            setQuantity(totalQuantity);
            setEnteredQuantity(0);

            closeCmodal(); // Close the modal
        } catch (error) {
            console.error('Error updating product in cart:', error);
        } finally {
            setLoading(false);
        }
    };

    // Use the entered quantity directly if provided, otherwise use the minimum quantity
    const totalQuantity = enteredQuantity > 0 ? enteredQuantity : quantity;

    const handleSelectMinimumQuantity = (qty) => {
        setQuantity(qty);
        setEnteredQuantity(0); // Clear the entered quantity when a minimum quantity is selected
    };

    return (
        <div>
            {isCmodalOpen && selectedMProduct && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-20">
                    <div className="bg-white p-6 rounded-lg max-w-md w-auto md:w-full shadow-lg">
                        <div className="flex justify-between items-center">
                            <h2 className="text-xl font-semibold mb-4">
                                {productData.name || 'Product Name'}
                            </h2>
                            <span
                                className="text-2xl cursor-pointer"
                                onClick={closeCmodal}
                            >
                                <IoCloseSharp />
                            </span>
                        </div>

                        <p className="line-clamp-2">{productData.description || 'No description available.'}</p>
                        <p className="text-lg font-bold mt-2">
                            Price: ₹{productData.price || '0.00'}
                        </p>

                        {/* Minimum Quantity Selection */}
                        <label className="block my-4">
                            <span className="text-gray-700">Select Minimum Quantity</span>
                            <div className="flex flex-row justify-between mt-2">
                                {[productData.min_order_quantity, productData.min_order_quantity_two,
                                    productData.min_order_quantity_three, productData.min_order_quantity_four,
                                    productData.min_order_quantity_five]
                                    .filter((qty) => qty)
                                    .map((qty) => (
                                        <div
                                            key={qty}
                                            onClick={() => handleSelectMinimumQuantity(qty)}
                                            className={`cursor-pointer p-4 border rounded-lg hover:border-brand-primary hover:text-brand-primary text-center ${
                                                quantity === qty && enteredQuantity === 0
                                                    ? 'bg-brand-primary transition ease-in-out hover:text-white duration-500 text-white'
                                                    : 'bg-white'
                                            }`}
                                        >
                                            {qty}
                                        </div>
                                    ))}
                            </div>
                        </label>

                        {/* Enter Quantity */}
                        <label className="block my-4">
                            <span className="text-gray-700">Enter Quantity</span>
                            <input
                                type="number"
                                value={enteredQuantity === 0 ? '' : enteredQuantity}
                                onChange={(e) => {
                                    const value = Number(e.target.value);
                                    setEnteredQuantity(isNaN(value) || value < 0 ? 0 : value);
                                }}
                                className="w-full p-2 border rounded mt-2"
                                placeholder="Enter quantity"
                                min="0"
                            />
                        </label>

                        <div className="mt-2 text-lg font-semibold">
                            Total Quantity: {totalQuantity}
                        </div>
                        <div className="mt-2 text-lg font-semibold">
                            Total Price: ₹{(productData.price * totalQuantity || 0).toFixed(2)}
                        </div>

                        {/* Action Button */}
                        <div className="flex justify-between space-x-4 mt-4">
                            <button
                                onClick={(e) => {
                                    e.preventDefault();
                                    editToCart(selectedMProduct, totalQuantity);
                                }}
                                className="hover:bg-brand-primary text-brand-primary px-4 py-2 rounded w-full border-brand-primary border-solid border-2 hover:text-brand-secondary-gray ease-in duration-200"
                                disabled={loading}
                            >
                                {loading ? 'Adding...' : 'Edit to Cart'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default CartModal;



